module.exports = __webpack_public_path__ + "static/truck_default-e79d6de4ae7d1743c675ee23e7284ef2.png";